import styled from 'styled-components'
import { colors, radiuses, highlight } from 'styles'
import { StyledCheckbox } from 'components/Controls/Checkbox'

const StyledFlagSetter = styled.div`
  width: 80vw;
  max-width: 120rem;
  display: flex;
  flex-wrap: wrap;
  margin: auto;
  background: ${colors.main};
  color: ${colors.mainInverted};
  border-radius: ${radiuses.large};
  font-size: 1.2rem;
  section {
    flex: 1 0 20rem;
    min-width: 30%;
    padding: 1rem;
  }
  h1 {
    text-align: center;
    text-transform: uppercase;
    font-size: 1.6rem;
  }
  .setting {
    display: flex;
    flex-wrap: wrap;
    padding: 1rem;
    cursor: pointer;
    border-radius: ${radiuses.medium};
    &:hover {
      background: ${p => highlight(0.1, p.theme.colors.main)};
    }
  }
  .input-wrapper,
  select,
  strong + button,
  ${StyledCheckbox} {
    margin-left: auto;
  }
  button,
  input {
    height: 28px; /* FF min value where type=number looks ok */
    box-sizing: border-box;
    border: none;
  }
  .input-wrapper input {
    width: 12rem;
  }
  .input-wrapper button {
    text-transform: uppercase;
    font-size: 2.3rem;
    padding: 0 0.5rem;
    line-height: 1;
    vertical-align: bottom;
    font-family: monospace;
    border: none;
  }
  ${StyledCheckbox} {
    font-size: 2rem;
    position: relative;
    width: 1em;
    height: 1em;
    padding: 0;
  }
  p {
    flex: 100%;
    opacity: 0.8;
    margin-top: 0.5em;
    margin-bottom: 0;
  }
`
export default StyledFlagSetter
